module.exports = __webpack_public_path__ + "static/prairie-process-serving-logo-a88238c126e3242ed4e01a91300cfe92.png";